import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';

export const unSubscribeBulkActionSubmitEvent = (subscriptionItemName: string) => {
  PubSubUtils.unsubscribe(APP_CONSTANTS.PUB_SUB_EVENTS.EVENT_BULKACTION, subscriptionItemName);
};

export const subscribeBulkActionSubmitEvent = (callback: Function, subscriptionItemName: string) => {
  PubSubUtils.subscribe(APP_CONSTANTS.PUB_SUB_EVENTS.EVENT_BULKACTION, callback, subscriptionItemName);
};
